import { Button, IconButton } from "@movicoders/movicoders-components";
import { Grid, Typography, Select, MenuItem } from "@mui/material";
import {
  AFE_ID,
  basicSizes,
  carbonSizes,
  Materials,
  shinpadOptionals,
  shinpadSizes,
} from "../../../../../constants/Application";
import { useTranslation } from "react-i18next";
import blackHolder from "../../../../../assets/images/blackHolder.jpg";
import whiteHolder from "../../../../../assets/images/whiteHolder.jpg";
import OwnColors from "../../../../../constants/OwnColors";
import { useShinpadTemplateStyles } from "../../styles/styles";
import ProductMenuAttributes from "../../../../../interfaces/ProductMenuAttributes";
import { Close } from "@mui/icons-material";
import polySizesImg from "../../../../../assets/images/polymeric_shinpad_sizes.jpg";
import carbonSizesImg from "../../../../../assets/images/carbon_shinpad_sizes.jpg";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { MaterialPriceHelper } from "../../../../../helpers/MaterialPriceHelper";

type TProductMenu = {
  changeTab: (value: number) => void;
  attributes: ProductMenuAttributes;
  setAttributes: (attributes: ProductMenuAttributes) => void;
};

export const ProductMenu = ({
  changeTab,
  attributes,
  setAttributes,
}: TProductMenu) => {
  const { t } = useTranslation();
  const classes = useShinpadTemplateStyles();
  const location = useLocation();
  const [materialPrices, setMaterialPrices] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    MaterialPriceHelper().getItemsPrice().then(setMaterialPrices).catch(console.error)
  }, [])

  const isAfe = useMemo(() => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("afe") === "true"
  }, [window.location.search])

  const setSize = (size: string) => {
    setAttributes({ ...attributes, size: size });
  };

  const setMaterial = (material: string) => {
    setAttributes({ ...attributes, material: material });
  };

  const setHolder = (holder: string) => {
    setAttributes({ ...attributes, extra: holder });
  };

  const getShinpadSize = () => {
    if (
      attributes.material === Materials.carbon.id ||
      attributes.material === Materials.flex.id
    )
      return carbonSizes;
    if (
      attributes.material === Materials.basic.id
    )
      return basicSizes;
    return shinpadSizes;
  };

  const getShinpadSizesImage = () => {
    if ([Materials.carbon.id, Materials.flex.id].includes(attributes.material))
      return carbonSizesImg;
    return polySizesImg;
  };

  const availableMaterials = useMemo(() => {
    const urlMatValues = new URLSearchParams(location.search).get("mat")?.split(";").filter(Boolean) || [];
    if (isAfe) {
      return Object.values(Materials).filter(material => material.id === AFE_ID)
    } else {
      const usableMaterials = Object.values(Materials).filter(material => material.id !== AFE_ID)
      const filteredMaterials = urlMatValues.length > 0
        ? usableMaterials.filter(material => urlMatValues.includes(material.id))
        : usableMaterials;
      return filteredMaterials.length > 0 ? filteredMaterials : usableMaterials
    }
  }, [location.search, Materials])

  const currentMaterialExists = availableMaterials.some(material => material.id === attributes.material);
  if (!currentMaterialExists && availableMaterials.length > 0) {
    setAttributes({ ...attributes, material: availableMaterials[0].id });
  }

  return (
    <Grid container style={{ padding: "5%", height: "100%" }}>
      <Grid item container xs={12} style={{ height: "fit-content" }}>
        <div className={classes.numberDiv}>1</div>
        <Typography style={{ color: "white", fontSize: "2rem" }}>
          {t("shinpadTemplateView.leftMenu.product.title")}
        </Typography>
        <Typography style={{ color: "#cccccc" }}>
          {t("shinpadTemplateView.leftMenu.product.description")}
        </Typography>
        <Grid
          container
          direction="column"
          style={{ color: "white", margin: "10px 0 10px 0" }}
        >
          <Grid
            container
            alignItems="center"
            style={{ justifyContent: "space-between" }}
          >
            <Typography
              style={{
                color: "#cccccc",
                fontWeight: "bold",
                marginRight: "2px",
              }}
              display="inline"
            >
              {t("shinpadTemplateView.leftMenu.carbon")}
            </Typography>
          </Grid>
          <Select
            value={attributes.material}
            variant="outlined"
            onChange={(event) => setMaterial(event.target.value)}
            style={{
              color: "white",
              backgroundColor: OwnColors.podoactivaGrey,
            }}
          >
            {availableMaterials.map((material, index) => (
              <MenuItem key={material.id + index} value={material.id}>
                {t(material.translation) + " " + (materialPrices.get(material.id) ? `(${materialPrices.get(material.id)}€)` : "")}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid
          container
          direction="column"
          style={{ color: "white", margin: "10px 0 10px 0" }}
        >
          <Grid container justifyContent="space-between">
            <Typography
              style={{
                color: "#cccccc",
                fontWeight: "bold",
                marginBottom: "4px",
              }}
            >
              {t("shinpadTemplateView.leftMenu.size")}
            </Typography>
            <a
              target="_blank"
              rel="noreferrer"
              href={getShinpadSizesImage()}
              style={{
                color: "#ababab",
                marginBottom: "4px",
              }}
            >
              {t("shinpadTemplateView.leftMenu.size.info")}
            </a>
          </Grid>
          <Select
            value={attributes.size}
            variant="outlined"
            onChange={(event) => setSize(event.target.value)}
            style={{
              color: "white",
              backgroundColor: OwnColors.podoactivaGrey,
            }}
          >
            {getShinpadSize().map((size, index) => (
              <MenuItem key={size + index} value={size}>
                {size}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        {!isAfe &&
          <Grid
            container
            direction="column"
            style={{ color: "white", margin: "10px 0 10px 0" }}
          >
            <Grid
              container
              alignItems="center"
              style={{ justifyContent: "space-between" }}
            >
              <Typography
                style={{
                  color: "#cccccc",
                  fontWeight: "bold",
                  marginRight: "2px",
                }}
                display="inline"
              >
                {t("shinpadTemplateView.leftMenu.extra")}
              </Typography>
              <div
                style={{
                  borderRadius: "5px",
                  backgroundColor: OwnColors.podoactivaGrey,
                  width: "fit-content",
                  padding: "5px",
                }}
              >
                <Typography style={{ color: "#cccccc" }} display="inline">
                  Precio +9,5€
                </Typography>
              </div>
            </Grid>
            <Grid
              container
              wrap="wrap"
              style={{ columnGap: "5px", rowGap: "5px" }}
            >
              <IconButton
                icon={<></>}
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: 0,
                  backgroundImage: `url("${whiteHolder}")`,
                  backgroundSize: "100px",
                  border:
                    attributes.extra === shinpadOptionals[0]
                      ? "4px solid #a4a0a9"
                      : "",
                }}
                backgroundColor={"white"}
                onClick={() => {
                  setHolder(shinpadOptionals[0]);
                }}
                classIconButton={classes.backgroundIcon}
              />
              <IconButton
                icon={<></>}
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: 0,
                  backgroundImage: `url("${blackHolder}")`,
                  backgroundSize: "100px",
                  border:
                    attributes.extra === shinpadOptionals[1]
                      ? "4px solid #a4a0a9"
                      : "",
                }}
                backgroundColor={"white"}
                onClick={() => {
                  setHolder(shinpadOptionals[1]);
                }}
                classIconButton={classes.backgroundIcon}
              />
              <IconButton
                icon={<Close />}
                color="black"
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: 0,
                  border:
                    attributes.extra === shinpadOptionals[2]
                      ? "4px solid #a4a0a9"
                      : "",
                }}
                backgroundColor={"white"}
                onClick={() => {
                  setHolder(shinpadOptionals[2]);
                }}
                classIconButton={classes.backgroundIcon}
              />
            </Grid>
          </Grid>
        }

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}></Grid>
          <Grid item container xs={12} md={6} justifyContent="flex-end">
            <Button
              text={t("shinpadTemplateView.leftMenu.next")}
              onClick={() => {
                changeTab(2);
              }}
              style={{
                fontWeight: "bold",
                width: "95%",
                border: "2px solid white",
              }}
              textColor="white !important"
              hoverColor="white !important"
              backgroundColor={`${OwnColors.buttonBlack} !important`}
              hoverBackgroundColor={`${OwnColors.buttonBlackHover}  !important`}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
